import 'jquery';
import 'slick-carousel';

// Import everything from autoload
import './autoload/_bootstrap.js';

import * as Func from './func';

// Load Events
$(document).ready(() => {
  Func.handleToggleMobileTopMenu();
  Func.handleToggleShowSubMenu();
  Func.createTestimonialSlider();
  Func.handleLoadPosts();
  //Func.handleCustomForms()
  Func.handleSearch();
  //Func.handleGravityForms()
  Func.createImageSlider();
  Func.handleBackgroundVideoControls();
});



// WEBPACK FOOTER //
// ./scripts/main.js